import {
  OreCardContainer,
  OreCardWrapper,
  OreStack,
  OreText,
  SvgChevronDown,
  SvgChevronUp,
} from '@edenredespana/oreneta'
import { useState } from 'react'

import defaultImg from '@/Shared/ui/assets/help-center-icon.svg'

interface IProps {
  image?: string
  title: string
  description: string
  children: React.ReactNode
}

export const ExpandableFaq = ({
  image,
  title,
  description,
  children,
}: IProps): JSX.Element => {
  const [faqOpen, setFaqOpen] = useState<boolean>(false)

  return (
    <OreCardContainer>
      <OreCardWrapper>
        <OreStack direction="row" placeContent="space-between" space="large">
          <OreStack direction="row" placeItems="center">
            <img src={image ?? defaultImg} alt="" style={{ width: '90%' }} />
            <OreText bold>{title}</OreText>
          </OreStack>
          <OreStack direction="row" placeContent="center">
            <OreText>{description}</OreText>
            <div
              className="pointer"
              onClick={() => {
                setFaqOpen(!faqOpen)
              }}
            >
              {faqOpen ? <SvgChevronUp /> : <SvgChevronDown />}
            </div>
          </OreStack>
        </OreStack>
        {faqOpen && <div className="pt-2 px-1 pb-1">{children}</div>}
      </OreCardWrapper>
    </OreCardContainer>
  )
}
